import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/App.css';

// 所有页面直接加载，确保点击即开
import Home from './pages/Home';
import Test from './pages/Test';
import Result from './pages/Result';
import Details from './pages/Details';
import Introduction from './pages/Introduction';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/test/:type" element={<Test />} />
          <Route path="/result/:type" element={<Result />} />
          <Route path="/details/:type" element={<Details />} />
          <Route path="/introduction" element={<Introduction />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
